import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import { defaultRoutes } from 'components/MainRouter/constants';

const { sportPrematch } = defaultRoutes;

const useIsPrematch = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const pathComponents = pathname.split('/');

    return `/${pathComponents[1]}` === sportPrematch;
  }, [pathname]);
};

export default useIsPrematch;
